import { useContext, useRef } from "react";
import MultiComparisonComponent from "../../Dashboard/Component/MultiComparisonComponent";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import classes from "./CompetitiveSummary.module.css";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import { AuthContext } from "../../../context/auth-context";
import Checkbox from "@mui/material/Checkbox";
import { tab } from "../BrandScore/BrandScore";

export default function CompetitiveSummary() {
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;
  let primary_llm = discoveryCtx.primary_llm;
  let llms = discoveryCtx.llm;
  let market = discoveryCtx.markets[0];
  let categories = discoveryCtx.category;
  const selectedCategory = discoveryCtx.state.selectedCategory;
  let competitors = discoveryCtx.competitors[selectedCategory].map(
    (c) => c.name
  );
  competitors.unshift(discoveryCtx.entity);
  const id = "Competitor_Summary";
  /*we need to pass uniqueKey because it only selectedCategory*/
  let uniqueKey = `${id}_${selectedCategory}`;
  const { checked } = useIsSelectedSection({
    id,
    tab: tab.competitiveOverview,
    uniqueKey,
  });
  const getBrandScores = (type) => {
    const brandScoresMap = {};
    // let mainBrandProduct = "";

    llms?.forEach((llmName) => {
      const scores = discoveryCtx?.brand_scores?.[llmName] || {};
      const market = discoveryCtx.markets[0];
      const categories = Object.keys(scores);

      const categoryScores = scores[selectedCategory] || {};
      const marketScores = categoryScores[market] || [];

      if (!Array.isArray(marketScores) || marketScores.length === 0) {
        console.warn(
          `No marketScores found for category "${selectedCategory}"`
        );
        return;
      }

      // if (!mainBrandProduct) {
      //     mainBrandProduct = llmName;
      // }

      if (!brandScoresMap[llmName]) {
        brandScoresMap[llmName] = {};
      }

     marketScores.forEach((score, idx) => {
      if (!score || typeof score !== "object") {
        console.warn(`Invalid score object at index ${idx} for llm "${llmName}"`);
        return;
      }

      // Reorder: current score first, then others
      const reordered = [
        score?.[type] ?? null, // safe lookup
        ...marketScores
          .filter((_, i) => i !== idx)
          .map((item) => (item && type in item ? item[type] : null)),
      ];

      brandScoresMap[llmName][score.name || `unknown_${idx}`] = reordered;
    });
    });

    return { brandScoresMap };
  };

  const getBrandDomains = () => {
    const competitors = discoveryCtx.competitors;
    const categories = Object.keys(competitors);
    const brandDomains = {};
    // const mainProduct = getBrandScores("favorability").mainBrandProduct;
    categories.map((category) => {
      competitors[category].map((record) => {
        // if (mainProduct.toLowerCase() == record.name.toLowerCase()) {
        //     brandDomains[mainProduct] = record.domain;
        // } else {
        brandDomains[record.name] = record.domain;
        // }
      });
    });
    return brandDomains;
  };

  const getIndexScoreMetaData = () => {
    let indexScoreMetaData = [];
    llms.forEach((llm) => {
      const brandIndexScores = discoveryCtx?.brand_scores?.[llm] || {};
      const categories = Object.keys(brandIndexScores);
      categories.map((category) => {
        indexScoreMetaData[category] = {};
        const marketScores = brandIndexScores[category] || {};
        const primaryMarketScore = marketScores[discoveryCtx.markets[0]] || [];
        console.log("primaryMarketScore", primaryMarketScore);
        indexScoreMetaData = indexScoreMetaData.concat(
          primaryMarketScore.map((score) => {
            return {
              ...score,
              category: category,
              market: discoveryCtx.markets[0],
              llm: llm,
              persona: "General Persona",
              geography: "",
            };
          })
        );
      });
    });
    return indexScoreMetaData;
  };

  return (
    <>
      <div className="Heading-checkbox">
        <div className={classes.dropdownWrapper}>
          <div style={{display:'flex',gap:'10px' ,alignItems:'center'}}>
          <h5>Competitor Summary</h5>
           {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: "Competitor Summary",
                  tab: tab.competitiveOverview,
                  uniqueKey,
                  llm:null,
                  competitor:null,
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
          </div>
          <MUISelect
            fullWidth={false}
            optionValue={discoveryCtx.state.selectedCategory}
            label={"Category"}
            options={(discoveryCtx.category || []).map((category) => {
              return {
                name: category,
                value: category,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedCategory(e.target.value);
            }}
          />
        </div>
        <hr />

       
      </div>
      <hr />
      <MultiComparisonComponent
        fetchRealTimeActionsSources={() => { }}
        sourceURLIds={[]}
        reachSourceData={{}}
        sentimentSourceData={{}}
        categoryDimensionRatingSource={{}}
        secCategoryIndexScoreMetaData={{}}
        coreAttSourceData={{}}
        positiveAttSource={{}}
        negativeAttSource={{}}
        customerId={customerId}
        selectedInput={{
          llm: primary_llm,
          market: market,
          persona: "General Persona",
          brand: discoveryCtx.entity,
          product: null,
          geography: "",
          category: selectedCategory,
        }}
        productTaxonomyData={{}}
        secCategoryBrandFav={{}}
        secCategoryReach={{}}
        secCategoryBrandIndex={{}}
        indexScoreMetaData={getIndexScoreMetaData()}
        compCoreAttributes={{}}
        compCategoryDimensions={{}}
        pastCompCategoryDimensions={{}}
        pastCompCoreAttributes={{}}
        pastsecCategoryBrandIndex={{}}
        pastIndexScoreObj={{}}
        brandIndex={getBrandScores("total").brandScoresMap}
        brandReach={getBrandScores("rank").brandScoresMap}
        brandFav={getBrandScores("favorability").brandScoresMap}
        positiveAttributes={{}}
        negativeAttributes={{}}
        llmDomains={{}}
        geoLogo={{}}
        activeTab={"category"}
        brandDomains={getBrandDomains()}
        brandProduct={discoveryCtx.entity}
        type={discoveryCtx.type == "brand" ? "Brand" : "Product"}
        brandProductCategory={discoveryCtx.category}
        isBrandAuditPage={true}
        isBrandAuditMarketPage={true}
        competitiveOverview={competitors}
        isOverview={true}
        id={id}
      />
    </>
  );
}
